import { experimentType } from '@doordash/lib-feature-flags'
import * as Exp from './experimentConstants'

const { createExperimentToFeatureFlagMap } = experimentType

const experimentToFeatureFlagMap = createExperimentToFeatureFlagMap([
  experimentType.create('test_exp', {
    treatment: { test: true },
    control: { test: false },
  }),
  experimentType.create('dropshipping_skip_selection', {
    treatment: { dropshipping_skip_selection: true },
    control: { dropshipping_skip_selection: false },
  }),
  experimentType.create('ca_bgc_checkr_redirect', {
    treatment: { ca_bgc_checkr_redirect: true },
    control: { ca_bgc_checkr_redirect: false },
  }),
  experimentType.create('dropshipping_ab', {
    treatment: { dropshipping_ab: true },
    control: { dropshipping_ab: false },
  }),
  experimentType.create('dropshipping', {
    treatment: { dropshipping: true },
    control: { dropshipping: false },
  }),
  experimentType.create('instant_dashing', {
    treatment: { instant_dashing: true },
    control: { instant_dashing: false },
  }),
  experimentType.create('canada_dropshipping_embed_checkr_flow', {
    treatment: { canada_dropshipping_embed_checkr_flow: true },
    control: { canada_dropshipping_embed_checkr_flow: false },
  }),
  experimentType.create('dropshipping_status', {
    treatment: { dropshipping_status: true },
    control: { dropshipping_status: false },
  }),
  experimentType.create('enable_i18n_language_selection', {
    treatment: { enable_i18n_language_selection: true },
    control: { enable_i18n_language_selection: false },
  }),
  experimentType.create('bank_onboarding', {
    treatment: { bank_onboarding: true },
    control: { bank_onboarding: false },
  }),
  experimentType.create(Exp.RETURN_TO_APPLICATION_AUTO, {
    treatment: { return_to_application_auto: true },
    control: { return_to_application_auto: false },
  }),
  experimentType.create(Exp.INSTANT_DASHING_V2, {
    treatment: { [Exp.INSTANT_DASHING_V2]: true },
    control: { [Exp.INSTANT_DASHING_V2]: false },
  }),
  experimentType.create('in_app_education_v3', {
    treatment: { in_app_education_v3: true },
    control: { in_app_education_v3: false },
  }),
  experimentType.create('dasher_signup_ui_refresh', {
    treatment: { dasher_signup_ui_refresh: true },
    control: { dasher_signup_ui_refresh: false },
  }),
  experimentType.create(Exp.DX_CRO_LP_GRADUATION_Q1_2020, {
    treatment: { [Exp.DX_CRO_LP_GRADUATION_Q1_2020]: true },
    control: { [Exp.DX_CRO_LP_GRADUATION_Q1_2020]: false },
  }),
  experimentType.create(Exp.DX_ID_FAST_PAY_Q1_2020, {
    treatment: { [Exp.DX_ID_FAST_PAY_Q1_2020]: true },
    control: { [Exp.DX_ID_FAST_PAY_Q1_2020]: false },
  }),
  experimentType.create(Exp.NEEDS_VEHICLE_INFO, {
    treatment: { [Exp.NEEDS_VEHICLE_INFO]: true },
    control: { [Exp.NEEDS_VEHICLE_INFO]: false },
  }),
  experimentType.create(Exp.DX_EXTREME_LATENESS, {
    treatment: { [Exp.DX_EXTREME_LATENESS]: true },
    control: { [Exp.DX_EXTREME_LATENESS]: false },
  }),
  experimentType.create(Exp.W_MODEL_EXPERIMENT, {
    treatment: { [Exp.W_MODEL_EXPERIMENT]: true },
    control: { [Exp.W_MODEL_EXPERIMENT]: false },
  }),
  experimentType.create(Exp.NEEDS_OFFER_LETTER, {
    treatment: { [Exp.NEEDS_OFFER_LETTER]: true },
    control: { [Exp.NEEDS_OFFER_LETTER]: false },
  }),
  experimentType.create(Exp.DX_PHONE_NUMBER_VERIFICATION, {
    treatment: { [Exp.DX_PHONE_NUMBER_VERIFICATION]: true },
    control: { [Exp.DX_PHONE_NUMBER_VERIFICATION]: false },
  }),
  experimentType.create(Exp.TOKENIZATION, {
    treatment: { [Exp.TOKENIZATION]: true },
    control: { [Exp.TOKENIZATION]: false },
  }),
  experimentType.create(Exp.DX_WEB_JAPAN_SUPPORT, {
    treatment: { [Exp.DX_WEB_JAPAN_SUPPORT]: true },
    control: { [Exp.DX_WEB_JAPAN_SUPPORT]: false },
  }),
  experimentType.create(Exp.DX_PHONE_NUMBER_VERIFICATION_SIGNUP, {
    treatment: { [Exp.DX_PHONE_NUMBER_VERIFICATION_SIGNUP]: true },
    control: { [Exp.DX_PHONE_NUMBER_VERIFICATION_SIGNUP]: false },
  }),
  experimentType.create(Exp.NO_W9_EXPERIMENT, {
    treatment: { [Exp.NO_W9_EXPERIMENT]: true },
    control: { [Exp.NO_W9_EXPERIMENT]: false },
  }),
  experimentType.create(Exp.ADDRESS_COLLECTION_AFTER_DASH, {
    treatment: { [Exp.ADDRESS_COLLECTION_AFTER_DASH]: true },
    control: { [Exp.ADDRESS_COLLECTION_AFTER_DASH]: false },
  }),
  experimentType.create(Exp.IDENTITY_VERIFICATION, {
    treatment: { [Exp.IDENTITY_VERIFICATION]: true },
    control: { [Exp.IDENTITY_VERIFICATION]: false },
  }),
  experimentType.create(Exp.IDENTITY_VERIFICATION_ANDROID, {
    treatment: { [Exp.IDENTITY_VERIFICATION_ANDROID]: true },
    control: { [Exp.IDENTITY_VERIFICATION_ANDROID]: false },
  }),
  experimentType.create(Exp.BGC_UPDATE_FORM_VALIDATION, {
    treatment: { [Exp.BGC_UPDATE_FORM_VALIDATION]: true },
    control: { [Exp.BGC_UPDATE_FORM_VALIDATION]: false },
  }),
  experimentType.create(Exp.BGC_STATUS_UPDATE, {
    treatment: { [Exp.BGC_STATUS_UPDATE]: true },
    control: { [Exp.BGC_STATUS_UPDATE]: false },
  }),
  experimentType.create(Exp.DX_SAFETY_COURSE, {
    treatment: { [Exp.DX_SAFETY_COURSE]: true },
    control: { [Exp.DX_SAFETY_COURSE]: false },
  }),
])

export default experimentToFeatureFlagMap
